// extracted by mini-css-extract-plugin
export default {"div1":"account_div1__SSsod","div2":"account_div2__dlR5-","links":"account_links__USojI","div3":"account_div3__2iUKj"};